import SubscriptionPay from "./SubscriptionPay";
export default SubscriptionPay;